import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PopoverDeleteSchedulePage } from './popover-delete-schedule.page';

const routes: Routes = [
  {
    path: '',
    component: PopoverDeleteSchedulePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PopoverDeleteSchedulePageRoutingModule {}
